import { fmtDate, fmtDateTime } from '../../lib/format';
import React from 'react';
import { Timeline, Empty } from 'antd';

export interface TimelineEvent {
  ts: string;
  label: string;
  actor?: string | null;
  note?: string | null;
  color?: string;
}

/** ComplianceTimeline — the event history for an erasure request, legal hold, or
 * lifecycle subject. Ordered newest-first by the caller. */
export const ComplianceTimeline: React.FC<{ events: TimelineEvent[] }> = ({ events }) => {
  if (!events.length) return <Empty description="No events yet" image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  return (
    <Timeline
      items={events.map((e) => ({
        color: e.color ?? 'blue',
        children: (
          <div>
            <div style={{ fontWeight: 600 }}>{e.label}</div>
            <div style={{ fontSize: 12, color: 'var(--muted-foreground, #7A8099)' }}>
              {fmtDateTime(e.ts)}
              {e.actor ? ` · ${e.actor}` : ''}
            </div>
            {e.note && <div style={{ fontSize: 13, marginTop: 2 }}>{e.note}</div>}
          </div>
        ),
      }))}
    />
  );
};

export default ComplianceTimeline;
